import { render, staticRenderFns } from "./CruiseOffers.vue?vue&type=template&id=648a857d&"
import script from "./CruiseOffers.vue?vue&type=script&lang=ts&"
export * from "./CruiseOffers.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports